// @flow

import type { BaseAddress } from './base-address'
import { buildBaseAddress } from './base-address'

export type VisitAddress = BaseAddress & {
  street: string,
  houseNumber: ?number,
  houseNumberExtension: ?string,
}

const buildVisitAddress = (): VisitAddress => {
  return {
    street: '',
    houseNumber: null,
    houseNumberExtension: null,
    ...buildBaseAddress()
  }
}

export {
  buildVisitAddress
}



// WEBPACK FOOTER //
// ./src/types/visit-address.js